import { Component, Input } from '@angular/core';
import { LoChip } from 'lo-design-system';

interface CapBadge {
	label: string;
	scope: string;
}

const ALL_BADGES: CapBadge[] = [
	{ label: 'Ads', scope: 'ads_management' },
	{ label: 'Insights', scope: 'instagram_manage_insights' },
	{ label: 'Publish', scope: 'instagram_content_publish' },
	{ label: 'Mentions', scope: 'instagram_manage_insights' },
	{ label: 'Marketplace', scope: 'instagram_creator_marketplace_discovery' },
	{ label: 'Social listening', scope: 'instagram_manage_insights' },
	{
		label: 'Partnership Ads (scope)',
		scope: 'instagram_branded_content_brand'
	}
];

@Component({
	standalone: true,
	selector: 'meta-fb-capabilities-row',
	imports: [LoChip],
	template: `
		@if (badges.length) {
		<div class="cap-row">
			@for (b of badges; track b.label) {
			<lo-chip>{{ b.label }}</lo-chip>
			}
		</div>
		}
	`,
	styles: [
		`
			:host {
				display: block;

				.cap-row {
					display: flex;
					flex-wrap: wrap;
					gap: var(--lo-space-gap-sm);
				}
			}
		`
	]
})
export class MetaFbCapabilitiesRowComponent {
	@Input() scopes: string[] = [];

	get badges(): CapBadge[] {
		return ALL_BADGES.filter(b => this.scopes.includes(b.scope));
	}
}
